define('components/photoset/layouts/fitColumn/processors/align', [
    'components/photoset/complexNumber'
], function (ComplexNumber) {
    function Processor(options) {
        this.offset = options.offset;
        this.expand = options.expand;
    }

    Processor.prototype.process = function (rows) {
        ko.ignoreDependencies(function (offset) {
            _(rows).each(function (row) {
                var columns = _(row.columns()).filter(function (column) { return !this.expand() || !column.isEmpty() }, this),
                    redistributionData = _(columns).map(this._getWidthToRedistribute, this),
                    widthToRedistribute = _(redistributionData).reduce(function (result, value) { return result + value }, 0),
                    totalOffset = offset * (columns.length - 1);

                _(row.columns()).each(function (column, idx) {
                    var ratio = column.relWidth() / row.relWidth();

                    column.width(new ComplexNumber(ratio * 100, ratio * (widthToRedistribute - totalOffset) - redistributionData[idx]));
                });
            }, this);
        }, this, [this.offset()]);
    };

    Processor.prototype._getWidthToRedistribute = function (column) {
        return column.items().length > 1 ?
            this.offset() / column.relHeight() * (column.items().length - 1) :
            0;
    };

    return Processor;
});